/*
 * Contact page — "I'm writing as a business" toggle
 * Used by sections/page-contact-template.liquid
 *
 * Shows/hides the business fields and, while hidden, disables them and
 * clears their required state so they never block form submission.
 */
(function () {
  function initToggle(toggle) {
    var root = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!root) return;

    var fields = root.querySelectorAll('input, select, textarea');

    function sync() {
      var on = toggle.checked;
      root.hidden = !on;
      Array.prototype.forEach.call(fields, function (field) {
        field.disabled = !on;
        if (field.getAttribute('data-required') === 'true') {
          field.required = on;
        }
      });
    }

    toggle.addEventListener('change', sync);
    sync();
  }

  function init() {
    var toggles = document.querySelectorAll('.js-contact-business-toggle');
    Array.prototype.forEach.call(toggles, initToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
